import PropTypes from 'prop-types'

import { newRouteFor } from '@/utils/router'

const BisacBadge = ({ content: { link, name }, isAnchor = true }) => {
  return isAnchor
    ? (
      <li>
        <a
          className='pill-outline-secondary-branded-anchor'
          href={newRouteFor(link)}
        >
          {name}
        </a>
      </li>
    ) : (
      <li className='pill-outline-secondary-branded-anchor'>
        {name}
      </li>
    )
}

export default BisacBadge

BisacBadge.propTypes = {
  content: PropTypes.shape(
    {
      link: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }
  ),
  isAnchor: PropTypes.bool,
}
